import React, { useState, useEffect, useMemo } from 'react';
import { translate } from '../Services/translation';
const MAX_LEN = 300;

const ProductListHeaderText = ({ value }: { value?: string }) => {
  const [showMore, setShowMore] = useState(false);
  const wordLength = useMemo(() => value?.length ?? 0, [value]);

  const resultSubstr = useMemo(
    () => value?.substring(0, MAX_LEN) ?? '',
    [value]
  );
  const result = useMemo(
    () =>
      resultSubstr.substring(
        0,
        Math.min(resultSubstr.length, resultSubstr.lastIndexOf(' '))
      ),
    [resultSubstr]
  );

  useEffect(() => {
    setShowMore(wordLength >= MAX_LEN);
  }, [wordLength]);

  return (
    <>
      {!showMore && (
        <>
          <div
            className="mb-2 text-md [&_p:not(:last-child)]:mb-1"
            dangerouslySetInnerHTML={{
              __html: value ?? '',
            }}
          />
          {wordLength >= MAX_LEN && (
            <a
              className="cursor-pointer text-md underline"
              onClick={() => setShowMore(true)}
            >
              {translate('productlist.showless')}
            </a>
          )}
        </>
      )}
      {showMore && (
        <>
          <div
            className="mb-2 max-h-20 overflow-hidden break-words text-md"
            dangerouslySetInnerHTML={{
              __html: result,
            }}
          />
          <a
            className="cursor-pointer text-md underline"
            onClick={() => setShowMore(false)}
          >
            {translate('productlist.showmore')}
          </a>
        </>
      )}
    </>
  );
};

export default ProductListHeaderText;
